import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconColumnWideHalf"><Path d="M2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5V11.5H2V6.5Z" fill="currentColor"/><Path d="M2 12.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V12.5H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalf;
